import { useEffect, useState } from "react";
import axios from "axios";
import { INSTA_TILES } from "@/data/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Normalises Instagram Graph API items and provides graceful fallback tiles.
export default function useInstagramFeed(limit = 9) {
  const [state, setState] = useState({
    loading: true,
    live: false,
    items: [], // {id, image, permalink, caption}
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/instagram/latest`, {
          params: { limit },
          timeout: 12000,
        });
        if (cancelled) return;
        if (data?.configured && Array.isArray(data.items) && data.items.length > 0) {
          const items = data.items.slice(0, limit).map((it, i) => ({
            id: it.id || `ig-${i}`,
            image:
              it.media_type === "VIDEO"
                ? it.thumbnail_url || it.media_url
                : it.media_url || it.thumbnail_url,
            permalink: it.permalink,
            caption: it.caption || "",
            media_type: it.media_type,
          }));
          setState({ loading: false, live: true, items });
          return;
        }
      } catch (_e) {
        // fall through to static
      }
      if (cancelled) return;
      const items = INSTA_TILES.slice(0, limit).map((src, i) => ({
        id: `stock-${i}`,
        image: src,
        permalink: null,
        caption: "",
        media_type: "IMAGE",
      }));
      setState({ loading: false, live: false, items });
    })();
    return () => {
      cancelled = true;
    };
  }, [limit]);

  return state;
}
